import * as React from "react";
import { Outlet } from "react-router-dom";

import { Layout as StartLayout } from "@/components/start/layout/layout";

import { Page as NotFoundPage } from "@/pages/not-found";
import { Page as StartPage } from "@/pages/start";

import { route as authRoutes } from "./auth";
import { route as dashboardRoutes } from "./scadadashboard";
import { route as errorRoutes } from "./errors";


import { paths } from "../paths";
import { AppRouteObject } from "../components/feature/types/feature-types";


export const routes: AppRouteObject[] = [
    {
        element: (
            <StartLayout>
                <Outlet />
            </StartLayout>
        ),
        children: [
            { index: true, element: <StartPage /> },
        ],
    },
    {
        path: "*",
        element: <NotFoundPage />
    },
    {
        path: "theme",
        lazy: async () => {
            const { Page } = await import("@/pages/theme");
            return { Component: Page };       
        },
    },
    {
        path: paths.apiHealth,
        lazy: async () => {
            const { Page } = await import("@/pages/health");
            return { Component: Page };
        },
    },

    authRoutes,
    dashboardRoutes,
    errorRoutes,
];
